//const CDN_BASE_URL = 'https://sert-consumer.s3.amazonaws.com/images/classifications';
//const S3_BUCKET = 'sert-consumer/images/classifications';

export const MINORITY = "Minority";
export const BLACK = "Black Owned";
export const ASIAN = "Asian";
export const HISPANIC = "Hispanic";
export const NATIVE_AMERICAN = "Native American";
export const MENA = "MENA";
export const LGBTQ = "LGBTQ";
export const WOMEN = "Women Owned";
export const DISABILITY = "Disability";
export const VETERAN = "Veteran Owned";
export const SMALL_BIZ = "Small Business";

export const classificationsDisplayMap = {
    [ASIAN]: {
        //image:`${CDN_BASE_URL}/asian_sb.png`, 
        image: "./assets/asian_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Asian-Owned.zip",
        shortText: "Asian Owned",
        fullText: "Asian Owned Small Business"
    },
    [BLACK]: {
        //image:`${CDN_BASE_URL}/blackowned_sb.png`, 
        image: "./assets/blackowned_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Black-Owned.zip",
        shortText: "Black Owned",
        fullText: "Black Owned Small Business"
    },
    [DISABILITY]: {
        //image:`${CDN_BASE_URL}/disability_sb.png`,
        image: "./assets/disability_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Disability-Owned.zip",
        shortText: "Disability Owned",
        fullText: "Disability Owned Small Business"
    }, 
    [HISPANIC]: {
        //image:`${CDN_BASE_URL}/hispanic_sb.png`, 
        image: "./assets/hispanic_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Hispanic-Owned.zip",
        shortText: "Hispanic Owned",
        fullText: "Hispanic Owned Small Business"
    },
    [LGBTQ]: {
        //image:`${CDN_BASE_URL}/lgbtq_sb.png`, 
        image: "./assets/lgbtq_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-LGBTQ-Owned.zip",
        shortText: "LGBTQ Owned",
        fullText: "LGBTQ Owned Small Business"
    }, 
    [MENA]: {
        image: "./assets/smallbusiness_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-SmallBusiness.zip",
        shortText: "Middle Eastern or North African Owned",
        fullText: "Middle Eastern or North African Owned Business"
    }, 
    [MINORITY]: {
        //image:`${CDN_BASE_URL}/minority_sb.png`, 
        image: "./assets/minority_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Minority-Owned.zip",
        shortText: "Minority Owned",
        fullText: "Minority Owned Small Business",
    },
    [NATIVE_AMERICAN]: {
        //image:`${CDN_BASE_URL}/nativeamerican_sb.png`, 
        image: "./assets/nativeamerican_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-NativeAmerican-Owned.zip",
        shortText: "Native American Owned",
        fullText: "Native American Owned Small Business"
    },
    [SMALL_BIZ]: {
        //image:`${CDN_BASE_URL}/smallbusiness_sb.png`,
        image: "./assets/smallbusiness_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-SmallBusiness.zip",
        shortText: "Small Business",
        fullText: "Small Business"
    }, 
    [VETERAN]: {
        //image:`${CDN_BASE_URL}/veteran_sb.png`,
        image: "./assets/veteran_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Veteran-Owned.zip",
        shortText: "Veteran Owned",
        fullText: "Veteran Owned Small Business"
    }, 
    [WOMEN]: {
        //image:`${CDN_BASE_URL}/women_sb.png`, 
        image: "./assets/women_sb.png",
        zipFileS3Bucket: "images/classifications/social/",
        zipFileName: "Sertify-Woman-Owned.zip",
        shortText: "Women Owned",
        fullText: "Women Owned Small Business"
    }, 
};

export const TERMS_DATA_TYPES = {
    CITIZENSHIP: 'formAgreeCitizen',
    DIRECTCONSUMER: 'formAgreeDirectRelationship',
    INDEPENDENT: 'formAgreeIndependent',
    MAJORITY51: 'formAgreeOwnership',
    SMALLBIZ: 'formAgreeEmployeesSize',
};